import React from "react"
import "./TermsAndConditonsHtml.css"
export const TermsAndConditionsHtml = () => {
    return (
        <div>
            <p className="MsoNormal" align="center" style={{textAlign:"center"}}>
                <b>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>OPERATING AGREEMENT</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                    {'This Operating Agreement (“Agreement”) shall be effective and binding on all parties that utilize Lead Depot\u2019s (“Company”) resources relating to lead generation. By creating a login account through app.leaddepot.com, and using Lead Depot\u2019s site to contact leads, you hereby accept and consent to all the terms and conditions set forth herein, without modification, as well as any and all additional terms and conditions provided on the Website.'}
                </span>
            </p>
            <p className="MsoNormal" align="center" style={{textAlign:"center"}}>
                <b>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>TERMS AND CONDITIONS</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {"I. DEFINITIONS"}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'“Lead” means a potential Consumer that Company provided through Website, by means of providing the Consumer\u2019s contact information.'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'“Website” means leaddepot.com, which is also the domain name for Company\u2019s website which allows Customers to access Leads.'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'“Customer” means the person or entity that created a login account on Website and agrees to be bound by this Agreement. Customer is also used interchangeably throughout this Agreement with “you.”  '}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'“Consumer” means any individual who, without limitation, submits an RFQ Form to Company or Company\u2019s suppliers.'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'“Consumer Information” means the personally identifiable information obtained from Consumer who, without limitation, submits an RFQ Form to Company or Company\u2019s suppliers'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'“RFQ For” means a request for a price quote.'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'II. GENERAL CONDITIONS'}
                </span>
            </p>
            
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'A. Governing Law. This Agreement shall be construed under the laws of the State of California.'}
                </span>
            </p>
            
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'B. Jurisdiction and Venue. Any and all disputes and actions arising from this Agreement shall be in the Southern District of San Diego, California.'}
                </span>
            </p>
            
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'C. Privacy. Customer\u2019s use of Website shall be subject to Company\u2019s Privacy Policy, which governs the Website\u2019s data collection practices. You can find a link to Company\u2019s Privacy Policy at https://leaddepot.com/privacy-policy/.'}
                </span>
            </p>
            
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'D. Notices. Unless otherwise provided in this Agreement, Customer hereby consents that all notices, legal or otherwise, that are or are not required to be in writing, may be done so through electronic communications, including, but not limited to, sending emails, and/or visiting the Website.'}
                </span>
            </p>
            
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'E. Term. This Agreement shall remain in full force and binding on Customer so long as Customer has access to Website. This Agreement shall also remain in full force and binding on Customer for any and all matters, cause of actions, claims, liabilities, or damages relating to Leads accessed through the Website, regardless of whether Customer still has access to Website, for six years after Customer accessed Lead through the Website.'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'III. RESPONSIBILITIES OF PARTIES'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'A. Company Responsibilities. Company shall provide Customer with a list of Leads on a nonexclusive basis, subject to all limitations and restrictions of this Agreement, for a flat fee that shall be charged automatically to Customer\u2019ss credit card on file, upon Customer converting and/or securing a sale with each Lead accessed by Customer. All Leads provided by Company are accessible to all of Company\u2019ss customers. Company reserves the right to reach out to Leads provided to Customer for the purpose of determining whether or not a Lead was converted to a sale by any and all customers that have access to Leads. If Customer does not notify Company whether a Lead was converted to a sale or not, Company shall charge Customer\u2019ss credit card on file automatically two weeks after the date that Customer accessed the Lead. Company shall provide job value estimates, based on industry averages, regarding the type of services that Lead is requesting. For the avoidance of doubt, job value estimates are just that, estimates, and not guaranteed by Company for converting a Lead to a sale.  '}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'B. Customer Responsibilities. By accessing Lead\u2019s contact information through the Website, Customer agrees to all of the following:'}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    {"i."}
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    
                    </span>
                <u>
                    <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {'Flat Fee Per Converted Lead'}
                    </span>
                </u>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`.
                        Customer shall pay Company the flat fee, as described in Section IV below, for
                        each Lead that Customer converts to a sale. Each flat fee shall be charged in
                        accordance with Exhibit A, regardless of whether the job type or job value
                        estimate is accurately depicted on Website. For example, if a job request by
                        Lead is stated as “Roofing - New/Replace” on Website, the flat fee shall be
                        $199.00, regardless of whether the Lead later changes their request for service
                        or the estimated value is not reached. Similarly, if the Lead requests
                        additional services (i.e. in addition to “roofing - New/Replace”), Customer
                        shall not be liable for an extra flat fee. `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    {"ii."}
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </span>
                <u>
                    <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {'Notify Company of Sale'}
                    </span>
                </u>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`.                    
                    Customer shall notify Company of any and all Leads that Company converted into
                    a sale so that Company can charge Customer a flat fee. `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
            <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                {"iii."}
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                </span>
                <u>
                    <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {'Automatic Payment for Failing to Notify'}
                    </span>
                </u>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`. Customer consents and agrees to Company charging Customer\u2019s credit card automatically if Customer fails to notify Company whether Customer converted a Lead to a sale. Company shall impose this automatic charge on Customer\u2019s credit card two weeks after Customer first accessed a Lead\u2019s information, and, during that two-week period, failed to provide Company with notice that the Customer did not convert the Lead to a sale. `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
            <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                {"iv."}
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                </span>
                <u>
                    <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {'Damages for False Notification'}
                    </span>
                </u>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`. Whether intentional or not, if, through the procedures described under this Agreement, Company discovers that Customer converted a Lead to a sale, but (1) notified Company that the Lead was not converted to a sale, or (2) Company failed to immediately correct an otherwise false notification, then Company shall charge Customer double the amount of the flat fee as damages. This damages amount is to pay the flat fee cost for a converted Lead, as well as to offset the Company\u2019s costs to ensure that all customers subject to this Agreement are accurately complying with their responsibilities to notify Company of Leads that are converted to sales. `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
            <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                {"v."}
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                </span>
                <u>
                    <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {'No Sharing or Resale of Leads'}
                    </span>
                </u>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`. Customer acknowledges and agrees that any Leads acquired under this Agreement shall not be resold, re-marketed or otherwise provided by Customer to any third parties. Any such resale or impermissible transfer of a Lead or the data contained therein, as well as any such direct or indirect transfer, export, display, forward, share, or use of a Lead or the data contained therein shall constitute a misappropriation of Company\u2019s property, which necessarily inflicts grave harm on Company\u2019s business, and Customer expressly agrees to pay Company $500.00, per separate occurrence, as liquidated damages and not as a penalty, in addition to any other remedies available at law or in equity. Customer acknowledges and agrees that quantifying the amount of damages Company would incur as a result of misappropriation of a Lead, and/or the data contained therein would be difficult and expensive and that the foregoing measure of liquidated damages represents a reasonable estimation of ETN America\u2019 damages. `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
            <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                {"vi."}
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                </span>
                <u>
                    <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {'Legal Compliance'}
                    </span>
                </u>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`. Customer shall comply with all federal, state, local and industry laws, rules, regulations and requirements applicable to Customer\u2019s business and industry, and performance of this Agreement, including, without limitation, all laws regarding the offer and sale of products. Further, Customer shall be duly licensed, authorized and certified (as applicable) by all applicable government or regulatory authorities, at all necessary times, to offer services and sell products to Leads. Company shall not be liable or responsible for any actions or inactions of Customer. `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
            <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                {"vii."}
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                </span>
                <u>
                    <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {'Protect Account Information'}
                    </span>
                </u>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`. Company is not responsible for any lack of care by Customer to secure its own data (for example, sharing of Customer\u2019s username, password, or other account information, not logging out of Customer\u2019s account, etc.) or for any breach of security on Website. For the avoidance of doubt, Customer is responsible for any access to or use of Customer\u2019s account by Customer or any person or entity using Customer\u2019s username, password or other account information provided by Company to Customer, whether or not such access or use has been authorized by or on behalf of Customer, and whether or not such person or entity is an employee, agent, or representative of Customer. Customer shall maintain appropriate physical, technical and organizational measures to protect all Lead and Consumer Information provided hereunder against unauthorized access, use or disclosure. Customer shall: (i) notify Company promptly, in writing, and no later than twenty-four (24) hours following the occurrence of any apparent breach of security, such as loss, theft or unauthorized disclosure or use of Customer\u2019s user name, password, other account information or any Lead or Consumer Information transmitted to Customer hereunder; and (ii) provide all necessary and reasonable cooperation to Company to comply with any laws applicable to such security breach, including, without limitation, (a) the notification of all Leads or Consumers who may have a right to be informed of such breach and (b) the investigation and prosecution of such breach. `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
            <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                {"viii."}
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                </span>
                <u>
                    <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {'Refrain from Unlawful and Prohibited Uses'}
                    </span>
                </u>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`. Customer is granted a non-exclusive, non-transferable, and revocable license to access and use Website in strict accordance with this Agreement. Customer represents and warrants, as a condition precedent, that Customer will not use the Website for any unlawful or prohibited purpose, whether by law or in accordance with this Agreement. Customer shall not obtain, directly or indirectly, any information that is not made readily available or provided through the Website. Under no circumstances shall Customer attempt to resell any of Company\u2019s content. Customer shall not modify, publish, reverse engineer, transmit, create derivative works, or exploit any of Company\u2019s content, in whole or in part. Customer agrees that it shall only use Company\u2019s content for personal use in attempting to contact Lead for purposes of selling them on Customer\u2019s services.`}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
            <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                {"ix."}
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                </span>
                <u>
                    <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {'Intellectual Property'}
                    </span>
                </u>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`. Customer shall not make use of Company\u2019s intellectual property. All content included on Website, including, but not limited to, text, graphics, logos, images, and software is Company\u2019s intellectual property or Company\u2019s suppliers, and such intellectual property is protected by copyright and other laws and regulations that protect proprietary rights. Customer shall abide by all copyright and proprietary notices contained in such content and not alter them in any way. Customer\u2019s use of the Website does not entitle Customer to any ownership, proprietary or property rights, nor does it grant Customer any express or implied license to use Company\u2019s intellectual property except as expressly provided for in this Agreement.`}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
            <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                {"x."}
                <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
                </span>
                <u>
                    <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {'United States Users'}
                    </span>
                </u>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`. Customer shall only make use of Website and Leads if in compliance with all United States laws and regulations. If Customer accesses Website from any location outside the United States, Customer shall be solely responsible for compliance with all relevant international laws and regulations, as well as the laws and regulations of the United States (including federal, state and local laws and regulations in the United States). `}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'IV. PRICE AND PAYMENT TERMS'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'A. '}<i>Price</i>{". Customer shall pay Company a fixed price for each Lead that Customer converts to a sale in accordance with Exhibit A, which is hereby incorporated into this Agreement by reference. The amount of the sale is immaterial in that so long as a Lead paid Customer any sum of money, the fixed payment price shall be due. "}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'B. '}<i>Payment</i>{". Customer shall report to Company the status of a Lead, whether or not a Lead is converted to a sale, and shall do so in a reasonable time and manner. For the avoidance of doubt, whenever Customer access a Lead\u2019s information, it is the Customer\u2019s responsibility to inform Company as to whether the Lead was converted to a sale or not. If Customer accesses a Leads information and fails to report the status to Company within two weeks from the date Lead was initially accessed by Customer, then Customer shall be automatically charged the fixed price provided herein (i.e. section IV. A) in accordance with this Agreement. "}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'C. '}<i>Refunds</i>{". All charges are non-refundable. Regardless of whether a Lead was converted to a sale or not, Company shall have full and absolute discretion in determining whether or not to process a refund whenever a Customer is automatically charged the fixed price for failing to timely report a Lead\u2019s status in accordance with this Agreement.  "}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'V. CUSTOMER\u2019S CONSENT AND ADDITIONAL OBLIGATIONS'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'A. '}<i>Recordkeeping Obligation and Right to Audit</i>{". Customer shall maintain throughout the term of this Agreement, and until the conclusion of any applicable statute of limitations, under applicable local, state, and federal law, true and correct records of all information pertinent to Customer\u2019s use of Leads, including, but not limited to all communications between Customer and Leads, as well as all records of payments made by Leads to Customer. Customer shall deliver any and all records required under this Agreement to Company upon Company\u2019s request. If any records related to Customer\u2019s use of Leads are requested by a third party, including, without limitation, a government entity or regulatory authority, Customer shall, upon not less than five (5) days\u2019 written notice, provide Company, the third party, the government entity and/or the regulatory authority a true and correct copy of such records. Such prior written notice to Company shall identify the third party, government entity or regulatory authority to which such records must be delivered and the information that must be reported. Company or its agent shall be entitled to audit, at its expense, during regular business hours and upon not less than five (5) days' written notice, records of all information pertinent to Customer\u2019s use of the Leads for the purpose of verifying Customer\u2019s compliance with the data use, transfer and payment terms of this Agreement, including, without limitation, any/all local, state and federal email and/or telemarketing laws, rules and regulations, and for verifying accuracy of payments. Any such audit shall not be made more than twice per annum during the term of this Agreement, unless reasonably required and/or a prior audit has disclosed an improper use, transfer, or payment. If, based on any such audit, Company determines that Company was underpaid by an amount equal to or greater than the lesser of $5,000 or five percent (5%) for the period under audit, or that there has been an improper use or transfer of Lead data as contemplated herein, then the reasonable out-of-pocket costs incurred by Company in connection with the review (including reasonable accountants\u2019 and attorneys\u2019 fees) shall be reimbursed by Customer within five (5) days after demand therefor. Company may, once per annum and upon not less than twenty (20) days\u2019 written notice, audit Customer\u2019s policies, procedures, and internal controls to verify Customer\u2019s compliance with this Agreement and all applicable local, state and federal laws, rules, regulations and requirements. This audit may be performed by a request for materials.  "}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'B. '}<i>Assignment</i>{". Customer may not assign, transfer, or delegate any of its rights, responsibilities, duties or obligations under this Agreement without the prior written consent of Company. Any attempts to do so shall be null and void. Subject to the foregoing limitation, this Agreement, together with any agreements referenced and incorporated herein, shall inure to the benefit of and be binding upon Customer, their successors, administrators, heirs, and permitted assigns.  "}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'C. '}<i>{'Pre-Authorization to Charge Customer\u2019s Credit Card'}</i>{". All charges are non-refundable. Regardless of whether a Lead was converted to a sale or not, Company shall have full and absolute discretion in determining whether or not to process a refund whenever a Customer is automatically charged the fixed price for failing to timely report a Lead\u2019s status in accordance with this Agreement.  "}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'VI. COMPANY\u2019S RETAINED RIGHTS'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'By creating a login account through Website, Customer consents to all of Company\u2019s retained rights provided under this section.'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'A. '}<i>Changes to Terms</i>{". Company reserves the right, in its sole discretion, to change the terms of this Agreement as it pertains to offering Customer access to Website and/or Leads. The most current record of this Agreement will supersede all prior records, which shall be determined by the version of the Agreement made available at https://leaddepot.com/terms-and-conditions/. Customer acknowledges and agrees that it is Customer\u2019s responsibility to review and stay up to date on the most current version of the Agreement upon any notices it receives from Company.  "}
                </span>
            </p>1
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'B. '}<i>Right to Restrict or Terminate Access</i>{".  Company reserves the right to terminate Customer\u2019s access to the Website and any other related service, or portion thereof, at any time, and without notice, in Company\u2019s sole discretion, so long as it does not violate any local, state, or federal laws.  "}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'C. '}<i>{'Right to Share Customer\u2019s Use of Website and Services.'}</i>{".  Company reserves the right to terminate Customer\u2019s access to the Website and any other related service, or portion thereof, at any time, and without notice, in Company\u2019s sole discretion, so long as it does not violate any local, state, or federal laws.  "}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'VII. DISCLAIMERS, LIABILITIES, REPRESENTATIONS, AND WARRANTIES'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'A. '}<i>Representation and Warranty that Leads are TCPA Compliant</i>{".  Company represents and warrants that the Leads sold to Buyer pursuant to this Agreement will meet each of the following criteria:"}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    {"i."}
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </span>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`   The Leads will be obtained from Consumers solely and specifically interested in obtaining a quote for the applicable type of project indicated; `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    {"ii."}
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </span>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`   The Leads will be collected from mediums where Company or Company\u2019s suppliers has included notification, through its data collection vehicles, that the Consumer\u2019s or Lead\u2019s information is being collected for the purposes of obtaining quotes; `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    {"iii."}
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </span>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`   The Leads will be collected from Consumers who have provided prior express written consent required by law or regulation (including, but not limited to, Telephone Consumer Protection Act, 42 USC 227) so that Customer or designated agents, contractors or carriers may call the relevant telephone or mobile phone numbers contained within Lead for the purpose of providing quotes or connecting the Consumer with agents, attorneys, contractors or carriers, including but not limited to through the use of an automatic telephone dialing system; and `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    {"iv."}
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </span>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`   Company agrees to provide to Customer, upon request, proof of such express written consent for all Leads provided to Customer. `}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'B. DISCLAIMER OF LIABILITY AND WARRANTIES. EXECPT AS EXPRESSLY STATED HEREIN, COMPANY DISCLAIMS ALL OF THE FOLLOWING:'}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    {"i."}
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </span>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`   COMPANY AND/OR ITS SUPPLIERS MAKE NO REPRESENTATIONS OR WARRANTIES REGARDING THE RELIABILITY, AVAILABILITY, TIMELINESS, SUITABILITY, AND/OR ACCURACY OF THE INFORMATION, SOFTWARE, PRODUCTS, SERVICES, GRAPHICS, LEAD CONTACT INFORMATION, OR LEAD INFORMATION FOR ANY PURPOSE. `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    {"ii."}
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </span>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`   TO THE MAXIMUM EXTENT PERMITTED BY LAW, ALL THE MATERIALS, RESOURCES AND MATERIALS PROVIDED AND/OR USED ON THE WEBSITE ARE PROVIDED “AS IS” AND WITHOUT WARRANTY OR CONDITION OF ANY KIND. COMPANY HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS WITH REGARD TO SUCH INFORMATION, SOFTWARE, PRODUCTS, SERVICES, GRAPHICS, LEAD CONTACT INFORMATION, CUSTOMER’S COMMUNICATIONS WITH LEADS, OR LEAD INFORMATION, INCLUDING ALL CONDITIONS OR IMPLIED WARRANTIES OF MERCHANTABILITY, AND FITNESS FOR A PARTICULAR PURPOSE. `}
                </span>
            </p>
            <p className="MsoListParagraphCxSpFirst" style={{textIndent: ".5in"}}>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    {"iii."}
                    <span style={{font:"7.0p;Times New Roman"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </span>
                <span style={{
                        fontSize: "12.0pt",
                        lineHeight: "107%",
                        fontFamily: '"Times New Roman", serif'
                    }}>
                    {`   TO THE MAXIMUM EXTENT PERMITTED BY LAW, COMPANY AND/OR ITS SUPPLIERS SHALL IN NO EVENT BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCEDENTAL, CONSEQUENTIAL, SPECIAL OR DAMAGES OF ANY KIND, INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF USE, DATA, PROFITS, CAUSES OF ACTIONS, THIRD-PARTY CLAIMS, PERFORMANCE OF WEBSITE, INABILITY TO ACCESS CUSTOMER ACCOUNTS, FAILURE TO PROVIDE SERVICES, OR FOR ANY INFORMATION SOFTWARE, PRODUCTS, SERVICES, GRAPHICS, LEAD CONTACT INFORMATION, YOUR COMMUNICATIONS WITH LEADS, OR LEAD INFORMATION GENERALLY, WHETHER BASED ON CONTRACT, NEGLIGENCE, TORT, STRICT LIABILITY, FRAUD, OR DIRECT OR INDIRECT CONDUCT REGARDLESS OF WHETHER COMPANY HAS BEEN NOTIFIED OF THE POSSIBILITY OF DAMAGES. `}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'IF YOU DISSAGREE WITH ANY PORTION OF THIS DISCLAIMER OR THE TERMS OF USE PROVIDED IN THIS AGREEMENT, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE AND REFRAIN FROM USING THE WEBSITE.'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'B. '}<i>Indemnification</i>{".  Customer shall indemnify, defend, and hold harmless Company, its affiliates, their respective partners, directors, officers, employees, members, managers, shareholders, contractors, representatives and agents against any and all actions, claims, suits, proceedings, liabilities, losses, damages, expenses, and costs (including reasonable attorneys\u2019 fees and related expenses) (collectively, the “Claim”) including, without limitation, that which arises from or relates to use of the Leads or Lead related data, or any breach or alleged breach of this Agreement (including, without limitation, any representation or warranty contained herein) by Customer, its affiliates, or its/their respective partners, directors, officers, employees, members, managers, shareholders, contractors, representatives, and agents."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'C. '}<i>Confidentiality</i>{".  For purposes of this Agreement, “Confidential Information” shall mean all data and information, of a confidential nature or otherwise, disclosed during the term of this Agreement by one party (“Disclosing Party”) to the other party (“Receiving Party”), as well as information that the Receiving Party knows or should know that the Disclosing Party regards as confidential including, but not limited to: (i) Lead contact information, a party’s business plans, strategies, know how, marketing plans, suppliers, sources of materials, finances, business relationships, personally identifiable end-user information, pricing, technology, employees, trade secrets and other non-public or proprietary information whether written, verbal, recorded on tapes or in any other media or format; and (ii) any information marked or designated by the Disclosing Party as confidential. The Receiving Party agrees to hold all Confidential Information in trust and confidence and, except as may be authorized by the Disclosing Party in writing, shall not use such Confidential Information for any purpose other than as expressly set forth in this Agreement or disclose any Confidential Information to any person, company or entity, except to those of its employees and professional advisers: (a) who need to know such information in order for the Receiving Party to perform its obligation hereunder; and (b) who have entered into a confidentiality agreement with the Receiving Party with terms at least as restrictive as those set forth herein. Confidential Information shall not include any information that the Receiving Party can verify with substantial proof that: (a) is generally available to or known to the public through no wrongful act of the receiving party; (b) was independently developed by the Receiving Party without the use of Confidential Information; or (c) was disclosed to the Receiving Party by a third party legally in possession of such Confidential Information and under no obligation of confidentiality to the Disclosing Party. The Receiving Party agrees that monetary damages for breach of confidentiality may not be adequate and that the disclosing party shall be further entitled to injunctive relief, without the requirement to post bond."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'D. '}<i>Representations and Warranties</i>{".  Customer represents and warrants that: (i) Customer has the power and authority to enter into and perform Customer\u2019s obligations under this Agreement; (ii) when creating a login account on Website this Agreement will constitute a legal, valid, and binding obligation of Customer, enforceable against Customer in accordance with this Agreement\u2019s terms and conditions; (iii) Customer is in good standing in the state of Customer\u2019s organization; (iv) Customer is qualified to do business in each state in which Customer provides products and services and has in effect and good standing all licenses and permits necessary or required to provide such products and services; (v) Customer will not violate any federal, state, or local laws, rules, regulations, and ordinances, including, without limitation, the CAN-SPAM Act of 2003 (as amended), the Telephone Consumer Protection Act, the Fair Credit Reporting Act and any/all applicable state Do Not Call List requirements (collectively, “Laws”) applicable to Customer\u2019s products or services or Customer\u2019s performance hereunder; (vi) Customer will not violate the rights of any third party including, without limitation, infringement or misappropriation of any copyright, patent, trademark, trade secret or other proprietary/intellectual property right; (vii) Customer\u2019s products or services will not target consumers under the age of eighteen (18); (viii) Customer is not, nor is Customer acting on behalf of any person or entity that is prohibited from engaging in transactions with U.S. citizens, nationals, or entities under applicable U.S. law and regulation including, but not limited to regulations issued by the U.S. Office of Foreign Assets Control (“OFAC”); (ix) Customer is not, nor is Customer acting on behalf of any person or entity that is, a Specialty Designated National (“SDN”), as OFAC may so designate from time to time; (x) neither Customer, nor any employee of Customer, is or has been under investigation or fined by the Federal Trade Commission or any other governmental agency related to the offering of offer and sale of products and/or deceptive advertising; (xi) Customer shall implement such administrative, physical, and technical security measures as required by applicable Laws and/or as necessary, to: (a) ensure the secure handling, transmission, storage, and disposal of any/ all Consumer Information or Lead information which Customer holds or handles; (b) protect against any threats or hazards to the security and integrity of such Consumer Information or Lead information; (c) protect against any unauthorized access to or use of such Consumer Information or Lead information; (d) use commercially reasonable efforts to cause its permitted transferees to exercise, all due care with respect to all Consumer Information and Lead information and the collection, handling, delivery, processing and transmission thereof, including, without limitation, with respect to confidentiality and security and any consent or authorization necessary to use such information as contemplated hereby; (e) comply, and will use commercially reasonable efforts to cause its permitted transferees to comply, with all applicable privacy Laws with respect to their possession and use of any Lead information and Consumer Information (including, without limitation, the use, unauthorized access, confidentiality and security of Consumer Information (and procedures related to the foregoing)) and all applicable Laws regarding email marketing and telemarketing activities. Company represents and warrants that: (i) Company has the full power and authority to enter into the Agreement and to carry out its obligations hereunder; (ii) the Agreement will constitute the legal, valid, and binding obligation of Company to Customer, and is enforceable against Company in accordance with its terms and conditions; and (iii) Company will comply with all federal, state and local laws, rules, and regulations applicable to Company\u2019s performance under the Agreement."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'E. '}<i>Customer is Based or in Compliance with all United States Laws and Regulations</i>{".  Customer hereby represents and warrants that it is and shall be in compliance with all federal, state and local laws of the United States in which Customer is transacting business and using Lead information. Customer understands and acknowledges that Company and Website are made available customers that are based in the United States and who have proper business permits and licenses to provide the types of services that are being requested by Leads. If Customer fails to follow any portion of this provision, they will be held strictly liable and must also indemnify, defend and hold harmless Company its affiliates, their respective partners, directors, officers, employees, members, managers, shareholders, contractors, representatives and agents against any and all actions, claims, suits, proceedings, liabilities, losses, damages, expenses, and costs (including reasonable attorneys’ fees and related expenses) (collectively, the “Claim”) including, without limitation, that which arises from or relates to use of the Leads or Lead related data."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'VIII. MISCELLANEOUS PROVISIONS'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'A. '}<i>Entire Agreement</i>{".  This Agreement, in addition to all terms and conditions provided on Website, embodies the entire agreement and understanding between Customer and Company on the subjects addressed herein and supersedes all prior discussions, agreements, or understandings between Customer and Company, whether express or implied. If there are any conflicting terms, the terms of this Agreement shall take precedence."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'B. '}<i>Modification</i>{".  Except as expressly set forth herein, this Agreement may not be modified or amended except by an instrument in writing signed by both parties."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'C. '}<i>Severability</i>{".  If, for any reason, any provision or partial provision of this Agreement is held invalid, such invalidity shall not affect the remainder of such provision or any other provision of this Agreement not so held invalid, and each other provision, or portion thereof, shall, to the full extent consistent with law, continue in full force and effect."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'D. '}<i>Headings</i>{".  The headings of the paragraphs of this Agreement are inserted for convenience of reference only and are not intended to be a part of, or to affect the meaning or interpretation of, this Agreement."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'E. '}<i>Waiver</i>{".  The Parties agree that if, and to the extent that, any party does not require strict compliance with the provisions of this Agreement by any other party, that action or inaction shall not constitute a waiver of, or otherwise affect or prejudice in any manner, that party\u2019s future rights or remedies under this Agreement, including the right to subsequently require strict performance of such provisions. No waiver by any party of a breach of this Agreement by any other party shall be deemed to be a waiver of any other breach by that other party (whether before or after and whether or not of the same or similar nature), and no acceptance of payment or performance by any party after any breach by any other party shall be deemed to be a waiver of any breach by that other party, whether or not the first party knows of the breach at the time it accepts such payment or performance"}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'F. '}<i>Electronic Signatures</i>{".  Each Party agrees that this Agreement and any other documents to be delivered in connection herewith may be electronically executed in that Customer taking the affirmative action of creating a login account on Website is, in fact, accepting to be bound by this Agreement in its entirety."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'G. '}<i>Incorporation</i>{".  The introductory paragraph, recitals, and definitions set forth above are hereby incorporated by reference."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'H. '}<i>No Third-Party Beneficiaries</i>{".  Nothing in the Agreement is intended or shall be construed to give any person other than the parties hereto, their respective successors and assigns, any legal or equitable right, remedy or claim under or in respect of the Agreement or any provision contained herein. Each Party agrees that due to the unique nature of the Leads, Consumer Information, and other Confidential Information provided by Company to Customer hereunder, there may be no adequate remedy at law for any breach by Customer of its obligations hereunder, and that any such breach may result in irreparable harm to Company. Therefore, upon any such breach or threat thereof, Company shall be entitled to appropriate equitable relief, including without limitation injunctive relief, in addition to any and all remedies available at law."}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'I. '}<i>Notices</i>{".   Any and all notices, whether voluntary or required under this Agreement, to Company shall be made to:"}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'Lead Depot'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'Address: 16885 W Bernardo Dr, Suite #310. San Diego CA 92127'}
                </span>
            </p>
            <p className="MsoNormal">
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>
                {'Email: hello@leaddepot.com'}
                </span>
            </p>
            <p className="MsoNormal" align="center" style={{textAlign:"center"}}>
                <b>
                <span style={{
                    fontSize: "12.0pt",
                    lineHeight: "107%",
                    fontFamily: '"Times New Roman", serif'
                }}>EXHIBIT A</span>
                </b>
            </p>
            <div align="center">
                <table className="TableGrid" border="0" cellSpacing="0" cellPadding="0" width="507" style={{
                    width: "380.15pt",
                    borderCollapse: "collapse"
                }}>
                    <tbody>
                        <tr style={{height: ".2in"}}>
                            <td width="236" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                background: 'yellow',
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: ".2in"
                            }}>
                                <p className="MsoNormal" align="center" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                    <b>
                                        <span style={{color: "black"}}>{'SKU (Job Type/Description)'}</span>
                                    </b>
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                background: 'yellow',
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: ".2in"
                            }}>
                              <p className="MsoNormal" align="center" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                    <b>
                                        <span style={{color: "black"}}>Flat Fee Price Per Lead</span>
                                    </b>
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                background: 'yellow',
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: ".2in"
                            }}>
                              <p className="MsoNormal" align="center" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                    <b>
                                        <span style={{color: "black"}}>Estimated Value of Job Type/Description</span>
                                    </b>
                                </p>
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Roofing - New/Replace
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 199.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 10,500.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Flooring - New/Replace
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 99.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4,400.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Fencing - New/Replace
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 99.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2,300.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Garage Door - New/Replace
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 99.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6,250.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                HVAC - New/Replace
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 199.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 7,300.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Plumbing - New/Replace
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 99.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3,300.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Siding - New/Replace
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 199.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 10,500.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Tiling - New/Replace
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 99.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 750.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Door & Window - New/Replace
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 99.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 750.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Solar - Install
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 199.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 20,000.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Carpentry
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 500.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Cleaning
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 250.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Concrete
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 250.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}> 
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                    Electrical
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 99.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2,500.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Fencing - Repair
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 550.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Flooring - Repair
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 330.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Garage Door - Repair
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 300.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Handyman
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 300.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Extermination
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 250.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Home Security
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 575.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                HVAC - Repair
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 375.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Landscaping
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 199.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 7,000.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Locksmithing
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 250.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Painting
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 99.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3,250.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Plumbing - Repair
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 600.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Remodeling
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 199.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 50,000.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Roofing - Repair
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 750.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Siding - Repair
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 550.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Tiling - Repair
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 475.00
                                </p> 
                            </td>
                        </tr>
                        <tr style={{height: "14.5pt"}}>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                                <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "1.8pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                Door & Window  - Repair
                                </p>
                            </td>
                            <td width="236" valign="top" style={{
                                width: "78.1pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                              <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 59.00
                                </p>
                            </td>
                            <td width="256" valign="top" style={{
                                width: "176.65pt",
                                border: "solid windowtext 1.0pt",
                                padding: '2.5pt 5.3pt 0in 0in',
                                height: "14,5pt"
                            }}>
                               <p className="MsoNormal" style={{
                                    marginTop: "0in",marginRight: "0in", marginBottom: "0in", marginLeft: "3.5pt",
                                    textAlign: "center",lineHeight: "normal"
                                }}>
                                $&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1,000.00
                                </p> 
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    )
}

